import React from "react";
import "./MarketplaceProductCard.css";
import {
  Store,
  MapPin,
  ShieldCheck,
  PackageCheck
} from "lucide-react";
import { useNavigate } from "react-router-dom";

function MarketplaceProductCard({
  product,
  cart,
  setCart,
  selectedVariants,
  setSelectedVariants,
  setShowAddedMsg,
  setSelectedProduct
}) {
  const selected = selectedVariants[product._id];
  const navigate = useNavigate();
  const displayPrice =
  product.productType === "SALE"
    ? selected?.price ??
      (product.variants?.length
        ? Math.min(...product.variants.map(v => v.price))
        : product.price)
    : selected?.dailyPrice ??
      (product.variants?.length
        ? Math.min(...product.variants.map(v => v.dailyPrice))
        : product.dailyPrice);

  const handleAddToCart = () => {
    if (product.variants?.length > 0 && !selected) {
      alert("Please select a variant first.");
      return;
    }

    setCart((prev) => {
      const existing = prev.find(
        (item) =>
          item._id === product._id &&
          item.size === selected?.size
      );

      if (existing) {
        return prev.map((item) =>
          item._id === product._id &&
          item.size === selected?.size
            ? {
                ...item,
                quantity: item.quantity + 1
              }
            : item
        );
      }

      return [
        ...prev,
        {
          cartItemId:
    crypto?.randomUUID?.() ??
    `${Date.now()}-${Math.random()}`,

          _id: product._id,
          name: product.name,
          vendorProductCode: product.vendorProductCode,
          vendorId: product.vendor?._id,
           vendorName: product.vendor?.name,
          productType: product.productType,

          size: selected?.size,

          price:
            product.productType === "SALE"
              ? selected?.price ??
                product.price ??
                product.variants?.[0]?.price
              : undefined,

          dailyPrice:
            product.productType === "RENTAL"
              ? selected?.dailyPrice ??
                product.variants?.[0]?.dailyPrice
              : undefined,

          quantity: 1,

          days:
            product.productType === "RENTAL"
              ? 1
              : undefined
        }
      ];
    });

    setShowAddedMsg(true);

    setTimeout(() => {
      setShowAddedMsg(false);
    }, 1200);
  };

  return (
    
  <div
    className="marketplace-product-card"
    onClick={() => navigate(`/product/${product.vendorProductCode}`)}
  >
    {/* Left */}

    <div className="marketplace-product-image-wrapper">
      {product.imageUrl ? (
        <img
          src={product.imageUrl}
          alt={product.name}
          className="marketplace-product-image"
        />
      ) : (
        <div className="marketplace-product-image-placeholder">
          No Image
        </div>
      )}
    </div>

    {/* Right */}

    <div className="marketplace-product-content">

      <h3 className="marketplace-product-name">
        {product.name}
      </h3>
      {product.description && (
  <p className="marketplace-product-description">
    {product.description}
  </p>
)}

      {product.brand && (
        <div className="marketplace-product-brand">
          {product.brand}
        </div>
      )}

      <div className="marketplace-product-price">
  ₹{displayPrice}

  {product.productType === "SALE" && product.unit && (
    <span> / {product.unit}</span>
  )}

  {product.productType === "RENTAL" && (
    <span> / Day</span>
  )}
</div>

      <div className="marketplace-product-badge">
        <ShieldCheck size={15} />
        <span>Civilink Verified</span>
      </div>

      <div className="marketplace-product-vendor">
        <Store size={15} />
        <span>{product.vendor?.name}</span>
      </div>

      <div className="marketplace-product-location">
        <MapPin size={15} />
        <span>
          {product.vendor?.location?.city || "Location unavailable"}
          {product.distance != null ? ` • ${product.distance} km` : ""}
        </span>
      </div>

      {/* Variant Selection */}

      {product.variants?.length > 0 && (
        <div className="vendor-variant-list">
          {product.variants.map((v, i) => {
            const isSelected =
              selectedVariants[product._id]?.size === v.size;

            return (
              <label
                key={i}
                className={`vendor-variant-option ${
                  isSelected ? "selected" : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="radio"
                  name={`variant-${product._id}`}
                  checked={isSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() =>
                    setSelectedVariants((prev) => ({
                      ...prev,
                      [product._id]: {
                        size: v.size,
                        price: v.price,
                        dailyPrice: v.dailyPrice
                      }
                    }))
                  }
                />

                <span>
                  {v.size} – ₹
                  {product.productType === "RENTAL"
                    ? `${v.dailyPrice} / day`
                    : v.price}
                </span>
              </label>
            );
          })}
        </div>
      )}

      <div className="marketplace-product-stock">
        <PackageCheck size={15} />
        <span>In Stock</span>
      </div>
      

      <button
        className="marketplace-product-cart-btn"
        onClick={(e) => {
          e.stopPropagation();
          if (!localStorage.getItem("token")) {
  window.location.href = "/";
  return;
}
          handleAddToCart();
        }}
      >
        Add to Cart
      </button>

    </div>
  </div>
);
}

export default MarketplaceProductCard;